export default __webpack_public_path__ + "static/media/disc_conflict_sl_results.ce3b5472.png";